<template>
    <div class="form-field form-address" v-bind:class="{'has-suffix': suffix, 'form-required': requiredForm, 'form-readonly': readOnly, 'has-lang': lang}">
        <div class="form-label" v-show="label">
            <label>{{ label }}</label>
        </div>
        <div class="form-input">

            <div class="address-preview" v-show="previewMode">
                <span v-if="internalValue.company">{{ internalValue.company }}</span>
                <span v-if="internalValue.firstname || internalValue.lastname">{{ internalValue.firstname }} {{ internalValue.lastname }}</span>
                <span>{{ internalValue.street }}</span>
                <span v-if="internalValue.street_complement">{{ internalValue.street_complement }}</span>
                <span>{{ internalValue.postal_code }} {{ internalValue.locality }}</span>
                <span>{{ internalValue.country && internalValue.country.name ? internalValue.country.name : internalValue.country }}</span>

                <div class="actions">
                    <button @click="previewMode = false" class="bt-edit"><i class="icon icon-icon_pencil"></i></button>
                    <button @click="removeBranch" class="bt-remove"><i class="icon icon-icon_delete"></i></button>
                </div>
            </div>

            <div class="form-input-container" v-show="!previewMode">
                <div class="form-input-wrapper" rel="company">
                    <input type="text" value="" v-model="internalValue.company" placeholder="company"/>
                </div>
                <div class="form-input-wrapper" rel="firstname">
                    <input type="text" value="" v-model="internalValue.firstname" placeholder="firstname"/>
                </div>
                <div class="form-input-wrapper" rel="lastname">
                    <input type="text" value="" v-model="internalValue.lastname" placeholder="lastname"/>
                </div>
                <div class="form-input-wrapper" rel="street">
                    <input type="text" value="" v-model="internalValue.street" placeholder="street"/>
                </div>
                <div class="form-input-wrapper" rel="street_complement">
                    <input type="text" value="" v-model="internalValue.street_complement" placeholder="Complement"/>
                </div>
                <div class="form-input-wrapper" rel="postal_code">
                    <input type="text" value="" v-model="internalValue.postal_code" placeholder="Zipcode"/>
                </div>
                <div class="form-input-wrapper" rel="locality">
                    <input type="text" value="" v-model="internalValue.locality" placeholder="City"/>
                </div>
                <div class="form-input-wrapper" rel="country">
                    <form-select label="" multiple="false" v-model="internalValue.country" :default="internalValue.country_id ? internalValue.country_id : internalValue.country" :options="$store.state.countries"></form-select>
                </div>

                <div class="actions">
                    <button @click="previewMode = true" class="bt-edit"><i class="icon icon-icon_tick"></i></button>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: 'FormField',
        props: ['value','label','name','placeholder','suffix','lang','required','readonly','maxlength'],
        data: function () {
            return {
                internalValue: '',
                langClass:"",
                previewMode: true
            }
        },
        created: function() {
            this.internalValue = this.value;
            this.langClass = this.lang?"flag lang-"+this.lang:"";
            this.requiredForm = this.required && (this.required == 'true' || this.required == true) ? true : false
            this.readOnly = this.readonly && (this.readonly == 'true' || this.readonly == true) ? true : false
        },
        methods: {
            removeBranch: function()
            {
                this.internalValue = null
            }
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            },
            'internalValue'(newVal, oldVal) {
                this.$emit('input', this.internalValue);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/form/Branch.vue